export default __webpack_public_path__ + "static/media/s_kiddiaryicon.dc62479b.png";